






















import Vue from 'vue'
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

export default Vue.extend({
  name: 'PrevNextArrows',

  props: {
    previousItem: {
      type: Object as () => IBreadcrumbItemMenuItem,
      default: null,
    },
    nextItem: {
      type: Object as () => IBreadcrumbItemMenuItem,
      default: null,
    },
    stackVertically: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'bottom',
    },
  },

  computed: {
    disablePrevTooltip(): boolean {
      return (
        this.previousItem === null || this.previousItem.refNumber === undefined
      )
    },
    disableNextTooltip(): boolean {
      return this.nextItem === null || this.nextItem.refNumber === undefined
    },
    prevItemTooltipText(): string {
      if (this.disablePrevTooltip) {
        return ''
      }
      return `#${this.previousItem.refNumber}: ${this.previousItem.title}`
    },
    nextItemTooltipText(): string {
      if (this.disableNextTooltip) {
        return ''
      }
      return `#${this.nextItem.refNumber}: ${this.nextItem.title}`
    },
  },
})
